import { getField, updateField } from 'vuex-map-fields'
import getPlacementFilterModel from './models/placementFilters'

const placementFilters = {
  namespaced: true,
  state: {
    ...getPlacementFilterModel()
  },
  getters: {
    getField,
    getSearchObject: (state) => {
      return state
    }
  },
  mutations: {
    updateField,
    clearFilters: (state) => {
      Object.assign(state, getPlacementFilterModel())
    }
  },
  actions: {
    clearFilters: ({ commit }) => {
      return commit('clearFilters')
    }
  }
}

export default placementFilters
